export default __webpack_public_path__ + "static/media/5t.80ae86f5.jpg";